/**
 * Sentinel Role-filter values for the access flags that are not company-level
 * roles (super admin, group admin). Kept in a dependency-light module so the
 * toolbar can import them without pulling in the users-table hook's runtime
 * dependencies.
 */
export const SUPER_ADMIN_ROLE_FILTER = 'super_admin';
export const GROUP_ADMIN_ROLE_FILTER = 'group_admin';
